const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const gameWaitContainer = path.resolve('src/containers/GameWait/index.js')

  return createPage({
    path: router(route.path, {}),
    component: gameWaitContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
